exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".updateGuideFixedHeaderTitle.el-table__cell {\n  background: rgba(0, 0, 0, 0.5) !important;\n  border-color: rgba(0, 0, 0, 0.5) !important;\n}", ""]);

// exports
